import { LicenseProduct } from '../models/license-product';
import { COPILOT_APPLICATION_ID } from '../repositories/ams/ams.repository';

export function isCoPilotLicense(productLicense: LicenseProduct) {
  return productLicense.applicationId === COPILOT_APPLICATION_ID;
}
